import { Box } from '@ltvco/refresh-lib/theme';
import { NotFound } from 'routes';
import { ChatPage } from './ChatPage/ChatPage';
import { ChatProvider } from '@ltvco/refresh-lib/v2';
import { Routes, Route, Navigate } from 'react-router-dom';

export const ChatAIContainer = () => {
  return (
    <Box height="100vh" width="100%">
      <ChatProvider>
        <Routes>
          <Route path="/" element={<Navigate to="chat" replace />} />
          <Route
            path="photo-damage-analyzer/*"
            element={<Navigate to="chat/photo-damage-analyzer" replace />}
          />
          <Route path="chat/*" element={<ChatPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ChatProvider>
    </Box>
  );
};
